import { render } from "./UserArea.vue?vue&type=template&id=4c2f1972&ts=true"
import script from "./UserArea.vue?vue&type=script&lang=ts"
export * from "./UserArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__